export default __webpack_public_path__ + "static/media/full_face_new.59679ad6.png";